module.exports = __webpack_public_path__ + "media/two_white.385e1d2e.mp3";